document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) menuButton.addEventListener('click', () => menu.classList.toggle('is-open'));

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantSelect = root.querySelector('[data-variant-select]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-text]');
    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const sku = root.querySelector('[data-sku]');
    const stock = root.querySelector('[data-stock-status]');

    const updateVariantUI = () => {
      if (!variantSelect || variantSelect.tagName !== 'SELECT') return;
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) comparePrice.textContent = option.dataset.compare || '';
      if (sku) sku.textContent = option.dataset.sku || '';
      if (stock) {
        stock.textContent = available ? 'In stock' : 'Sold out';
        stock.classList.toggle('is-soldout', !available);
      }
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? 'Add to Cart' : 'Sold Out';
    };
    if (variantSelect) variantSelect.addEventListener('change', updateVariantUI);

    const qty = root.querySelector('[data-qty-input]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) - 1); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { if (qty) qty.value = Math.max(1, Number(qty.value || 1) + 1); });

    const mainImage = root.querySelector('.product-featured-image');
    root.querySelectorAll('[data-thumb-src]').forEach((thumb) => thumb.addEventListener('click', () => { if (mainImage) mainImage.src = thumb.dataset.thumbSrc; }));
  });
});
